<template>
  <section id="listing">
    <b-row>
      <b-col>
        <b-input-group>
          <template #prepend>
            <b-input-group-text>
              <v-icon icon="search"/>
            </b-input-group-text>
          </template>
          <b-input v-model="filter"/>
        </b-input-group>
      </b-col>
      <b-col>
        <b-pagination
            size="md"
            :total-rows="meta.total"
            v-model="currentPage"
            :per-page="perPage"
        />
      </b-col>
    </b-row>

    <b-table
        striped
        hover
        responsive
        :items="fetchListing"
        :fields="fields"
        :per-page="perPage"
        :current-page="currentPage"
        :filter="filter"
        ref="table">
      <template #cell(full_name)="{item}">
        <b-link :href="'speakers/' + item.id + '/edit'"
                v-text="item.full_name"></b-link>
      </template>
      <template #cell(actions)="{item}">
        <div
            class="text-center text-danger c"
            @click="destroy(item)">
          <v-icon icon="bin"/>
        </div>
      </template>
    </b-table>

    <b-pagination
        size="md"
        :total-rows="meta.total"
        v-model="currentPage"
        :per-page="perPage"
    />
  </section>
</template>

<script>
import axios from 'axios'
import moment from '../../moment'
import qs from 'qs'

export default {
  data() {
    return {
      moment: moment,
      filter: '',
      currentPage: 1,
      perPage: 25,
      fields: [
        {
          key: 'full_name',
          label: 'Name',
          sortable: false
        },
        {
          key: 'position',
          label: 'Position',
          sortable: false
        },
        {
          key: 'organization',
          label: 'Organization',
          sortable: false
        },
        {
          key: 'actions',
          label: ' '
        }
      ],
      meta: {}
    }
  },
  methods: {
    /**
     * Provide the speakers listing data.
     */
    fetchListing({currentPage, perPage, filter, sortBy, sortDesc}) {
      sortBy = sortBy ? sortBy : 'created_at'
      if (sortDesc) {
        sortBy = '-' + sortBy
      }
      let promise = axios.get('/api/speakers', {
        params: {
          page: currentPage,
          limit: perPage,
          filter: {'search': filter},
          sort: sortBy ? sortBy : 'created_at'
        },
        paramsSerializer: function (params) {
          return qs.stringify(params, {arrayFormat: 'repeat'})
        }
      })
      return promise.then(({data}) => {
        this.meta = data
        return data.data
      }).catch(error => {
        return []
      })
    },

    /**
     * Delete a speaker
     * @param item
     */
    destroy(item) {
      let confirmed = confirm('Are you sure?')
      if (!confirmed) return

      let promise = axios.delete('/speakers/' + item.id)
      return promise.then(() => {
        this.$refs.table.refresh()
      }).catch(error => {
        alert('The speakers could not be deleted.')
      })
    }
  }
}
</script>
